<!-- inicio hero con video-->
<section id="hero" class="hero">

    <div class="overlay"></div>
    <div class="vimeo-wrapper">
           
           <iframe [src]="homeHero_params.urlVideoSafe" width="1920" height="1080" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen class="heroTranslate" title="{{homeHero_params.preTitleHero}} {{homeHero_params.titleHero}}"></iframe>


   </div>

   <div class="container">

       <div class="row">
          <div class="col-lg-12 content-hero">

               <div data-aos="fade-right" class="col-lg-3 offset-lg-1 col-md-6 offset-md-0 col-sm-12 col-12">
                   <p>{{homeHero_params.preTitleHero}}</p>
                   <h1>{{homeHero_params.titleHero}}</h1>
               </div>

              <div data-aos="fade-left" class="col-lg-3 offset-lg-2 col-md-6 offset-md-0 col-sm-12 col-12">
                   <p>{{homeHero_params.mainTextHero}}</p>
                   <a class="btn btn-rco" routerLink="{{homeHero_params.mainButtonLinkHero}}"><p>{{homeHero_params.mainButtonTextHero}}</p></a>
               </div>

           </div>

       </div>

   </div>

   <div class="hero-showcase__footer"></div>
  
   <a routerLink="." [fragment]="'quienes'" class="scroll-down" title="{{homeHero_params.preTitleHero}} {{homeHero_params.titleHero}}"></a>


</section><!-- fin hero-->